import Artwork1 from "../images/mobile/Artwork1.png";
import Artwork2 from "../images/mobile/Artwork2.jpg";
import Artwork3 from "../images/mobile/Artwork3.png";
import Artwork3A from "../images/mobile/ArtworkStudentReportExample.png";
import Artwork4 from "../images/mobile/Artwork4.png";
import Artwork6 from "../images/mobile/Artwork6.jpg";
import Artwork7 from "../images/mobile/Artwork7.jpg";
import Artwork8 from "../images/mobile/Artwork8.jpg";
import Artwork10 from "../images/mobile/ArtworkSchedule2.jpg";
import Artwork11 from "../images/mobile/June 2025, E6/Artwork1.png";
import Artwork12 from "../images/mobile/June 2025, E6/ArtworkSchedule1.png";
import Artwork13 from "../images/mobile/June_2025_J3/Artwork1.png";
import Artwork14 from "../images/mobile/ArtworkJ3InfoDetail2568.png";
import Artwork16 from "../images/mobile/June 2025, E6/ArtworkSchedule2.png";
import Artwork17 from "../images/mobile/June_2025_J3/ArtworkSchedule1.png";
import Artwork18 from "../images/mobile/June_2025_J3/ArtworkSchedule2.png";

const YouTubeVideo1 = 'https://youtu.be/U3qV6JtctMg';
const YouTubeVideo2 = 'https://youtu.be/OBb4Hg1VjDM';
const YouTubeVideo3 = 'https://youtu.be/PdeQJZsdwjA';



export const galleryE6 = [
    Artwork11, YouTubeVideo1, Artwork2, Artwork3, YouTubeVideo3,
    Artwork3A, Artwork4, Artwork6, Artwork7, Artwork8, Artwork12, Artwork16
];

export const galleryJ1 = [
    Artwork1, YouTubeVideo1, Artwork2, Artwork3, YouTubeVideo2,
    Artwork3A, Artwork4, Artwork6, Artwork7, Artwork8, Artwork10
];

export const galleryJ3 = [
    Artwork13, YouTubeVideo2, Artwork3A, Artwork14,
    Artwork8, Artwork7, Artwork17, Artwork18
];